const $ = window.jQuery;
const $window = window.$window || $(window);

const StickyHeader = {
	init() {
		var headerHeight = $('#header').outerHeight();

		var scroll = $window.scrollTop();
		if (scroll >= 46.65) {
			$('#header').addClass('state--scrolled');
		} else {
			$('#header').removeClass('state--scrolled');
		}
	},
};

export default StickyHeader;
